import { ErrorMessage } from 'formik'
import { Calendar } from 'primereact/calendar'
import './timeRange.scss'
import { useEffect, useState } from 'react'
import { ClickAwayListener } from '@mui/material'

function TimeRange({
  onChange,
  startValue: initialStartValue,
  endValue: initialEndValue,
  hourFormat,
  startName,
  endName,
  toLabelClassName,
  timeRangeClassName,
  titleLabelClassName,
  className,
  weekly,
  setWeekly,
  required,
}) {
  const [isFromVisible, setIsFromVisible] = useState(false)
  const [isToVisible, setIsToVisible] = useState(false)

  const currentDate = new Date()
  const [startValue, setStartValue] = useState(initialStartValue || currentDate)
  const [endValue, setEndValue] = useState(initialEndValue || new Date(currentDate.getTime() + 60 * 60 * 1000))

  const handleFromVisibility = () => {
    setIsFromVisible(false)
  }

  const openFromVisibility = () => {
    setIsFromVisible(true)
  }

  const handleFromVisibleChange = () => {
    return null
  }

  const handleToVisibility = () => {
    setIsToVisible(false)
  }

  const openToVisibility = () => {
    setIsToVisible(true)
  }

  const handleToVisibleChange = () => {
    return null
  }

  useEffect(() => {
    const handleScroll = () => {
      if (isToVisible) {
        setIsToVisible(false)
      }
    }
    window.addEventListener('scroll', handleScroll, true)
    return () => {
      window.removeEventListener('scroll', handleScroll, true)
    }
  }, [isToVisible])

  useEffect(() => {
    const handleScroll = () => {
      if (isFromVisible) {
        setIsFromVisible(false)
      }
    }
    window.addEventListener('scroll', handleScroll, true)
    return () => {
      window.removeEventListener('scroll', handleScroll, true)
    }
  }, [isFromVisible])

  const handleStartChange = (e) => {
    const newStartValue = e.value
    setStartValue(newStartValue)

    const newEndValue = new Date(newStartValue.getTime() + 60 * 60 * 1000)
    setEndValue(newEndValue)

    onChange({
      ...e,
      target: {
        ...e.target,
        name: startName,
        value: newStartValue,
      },
    })

    onChange({
      ...e,
      target: {
        ...e.target,
        name: endName,
        value: newEndValue,
      },
    })
  }

  const handleEndChange = (e) => {
    setEndValue(e.value)
    onChange(e)
  }

  return (
    <div className={`${timeRangeClassName}`}>
      <div className='time-range-header flex justify-between'>
        <label className={titleLabelClassName} htmlFor=''>
          Time <span className='required-symbol'>{required ? '*' : ''}</span>
        </label>
        {weekly && (
          <p
            onClick={() => {
              setWeekly(true)
            }}
            className='weekly-p'
          >
            Weekly
          </p>
        )}
      </div>
      <div className='flex'>
        <div className='align-start'>
          <ClickAwayListener onClickAway={handleFromVisibility}>
            <Calendar
              onClick={openFromVisibility}
              className={`from-to-range ${className}`}
              id='calendar-12h'
              value={startValue}
              onChange={handleStartChange}
              timeOnly
              hourFormat={hourFormat}
              name={startName}
              visible={isFromVisible}
              onVisibleChange={handleFromVisibleChange}
              readOnlyInput
            />
          </ClickAwayListener>
          <ErrorMessage name={startName} component='div' className='error-msg' />
        </div>
        <label className={toLabelClassName} htmlFor=''>
          to
        </label>
        <div className='align-start'>
          <ClickAwayListener onClickAway={handleToVisibility}>
            <Calendar
              className={`from-to-range ${className}`}
              id='calendar-12h'
              value={endValue}
              onChange={handleEndChange}
              timeOnly
              hourFormat={hourFormat}
              name={endName}
              visible={isToVisible}
              onVisibleChange={handleToVisibleChange}
              onClick={openToVisibility}
              readOnlyInput
            />
          </ClickAwayListener>
          <ErrorMessage name={endName} component='div' className='error-msg' />
        </div>
      </div>
    </div>
  )
}

export default TimeRange
